import Api from "./Api";

export default {
  Get() {
    return Api().get("/role");
  },
  Details(id) {
    return Api().get(`/role/${id}`);
  },
  Update(data) {
    return Api().post(`/role/edit`, data);
  },
  Add(data) {
    return Api().post(`/role`, data);
  },
  Delete(data) {
    return Api().delete(`/role`, { data: data });
  },
};
